import { Button, Icon, Image, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useCreatePriceLabel, useGetProductSkuImages } from '@hero/hooks';
import { getFormattedPrice } from '@hero/utils';

import { PriceBreakdownDropdown } from '../PriceBreakdownDropdown';

import * as S from './style';

const HorizontalProductCard = ({ product, removeProduct }) => {
  const { t } = useTranslation();
  const { minSkuPrice, maxSkuPrice, isCAActMustBeApplied } = useCreatePriceLabel(product);

  const priceLabel = getFormattedPrice({
    min: minSkuPrice,
    max: maxSkuPrice
  });

  const images = useGetProductSkuImages({ product });

  return (
    <S.Wrapper>
      <S.HorizontalProductWrapper>
        <S.ProductImageWrapper>
          <Image src={images?.[0]?.url} width="100%" height="100%" alt={product.name} />
        </S.ProductImageWrapper>
        <S.ProductDescription>
          <Typography color="neutral" emphasis="500" variant="body2Bold">
            {product.brand?.name}
          </Typography>
          <Typography variant="caption1" color="neutral" lineClamp={2}>
            <div dangerouslySetInnerHTML={{ __html: product.name }} />
          </Typography>
          {(!Number.isNaN(minSkuPrice) || !Number.isNaN(maxSkuPrice)) && (
            <S.ProductPriceWrapper>
              <Typography variant="body2Bold">{priceLabel}</Typography>
              {/* {!regularPriceLabel && (
                <Typography variant="body2" style={{ textDecoration: 'line-through' }}>
                  {regularPriceLabel}
                </Typography>
              )} */}
            </S.ProductPriceWrapper>
          )}

          {isCAActMustBeApplied && <PriceBreakdownDropdown product={product} />}
        </S.ProductDescription>
        <S.ProductActions>
          <Button color="secondary" onClick={() => removeProduct(product)} variant="link">
            <Icon name="close" px={16} />
          </Button>
        </S.ProductActions>
      </S.HorizontalProductWrapper>
      {product?.skus?.length > 1 && (
        <S.SkuInfoWrapper>
          <Icon name="info" size="sm" color="var(--color-fg-weaker)" />
          <Typography variant="caption1Bold" color="fg" emphasis="weaker">
            {t('xVariantOfThisItemAdded', {
              count: product?.skus?.length
            })}
          </Typography>
        </S.SkuInfoWrapper>
      )}
    </S.Wrapper>
  );
};

HorizontalProductCard.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string,
    brand: PropTypes.shape({
      name: PropTypes.string
    }),
    skus: PropTypes.array
  })
};

export { HorizontalProductCard };
